import {createStrokeSVG} from './TEMPLATE'

// tabler: broadcast
export const StreamingLive_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M18.364 19.364a9 9 0 1 0 -12.728 0',
    'M15.536 16.536a5 5 0 1 0 -7.072 0',
    'M11 13a1 1 0 1 0 2 0a1 1 0 1 0 -2 0',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
